import { Box, alpha } from '@mui/material';
import type { CategoryColor } from '../../../../../themes/v2/theme';
import type { LabeledChipAppearance } from '../labeledChip.styles';

interface ChipLabelProps {
  color: CategoryColor;
  label: string;
  appearance?: LabeledChipAppearance;
  className?: string;
  testId?: string;
}

const ChipLabel = ({ color, label, appearance = 'default', className, testId }: ChipLabelProps) => (
  <Box
    component="span"
    className={className}
    test-id={testId}
    sx={(theme) => ({
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box',
      minWidth: 18,

      paddingInline: theme.spacing(0.25),
      borderRadius: `${theme.shape.borderRadiusSm}px`,
      color:
        appearance === 'overlay'
          ? theme.palette.common.white
          : theme.palette.custom.category[color],
      backgroundColor:
        appearance === 'overlay'
          ? theme.palette.accent.light
          : alpha(theme.palette.custom.category[color], 0.1),
    })}
  >
    {label}
  </Box>
);

export default ChipLabel;
